/*
 * Build flag for the legacy customer history surface (WU
 * PROJ-0062-WU-LEGACY-HISTORY-01; LOCKED PROGRAMME-DEC-LEGACY-CUSTOMER-
 * MIGRATION-V1 sinks 2/5). Same shape as transferEnabled / Shell's
 * arabicToggleEnabled: the surface renders ONLY when
 * VITE_LEGACY_HISTORY_ENABLED === 'true' — absent or anything else = OFF,
 * which is correct for stage and prod with zero env changes until my-api's
 * GET /me/history ships there. The env is injectable so tests can pin both sides.
 */
export function legacyHistoryEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_LEGACY_HISTORY_ENABLED === 'true'
}

/** The SINK 3 per-event drill-down on the Orders "Earlier with Trumin" card
 *  (backlog 1g): VITE_LEGACY_HISTORY_EVENTS_ENABLED === 'true' only. It sits
 *  INSIDE the sink 2 card, so it also needs VITE_LEGACY_HISTORY_ENABLED. */
export function legacyHistoryEventsEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_LEGACY_HISTORY_EVENTS_ENABLED === 'true'
}
